<template>
  <div class="operator-step-two_block">
    <div class="left">
      <h3 class="large_blue_label">2.マッチングした案件・クライアントの確認</h3>
      <p>条件に合致する案件が見つかると、オペレーターが登録したメールアドレス宛に案件および発注しているクライアントを紹介する通知を送ります。</p>
      <br>
      <p>オペレーターはそこで紹介された案件の内容とクライアントのプロフィールを確認し、受注希望を出すか、見送るか判断します。</p>
      <br>
      <p>ここで紹介されたクライアントには同じタイミングでオペレーターのプロフィールが紹介されており、</p>
      <p class="marker-underline_label">双方が発注希望、受注希望を出せばマッチング成立となります。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/op_five_steps_2.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "OperatorStepTwoBlock"
  }
</script>

<style lang="scss" scoped>
  .operator-step-two_block {
    @include double_columns(40%, 35%);

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>